export const ADD_ON_PURCHASE_MESSAGES = {
  firstPurchase: "尝鲜价",
  repurchase: "优惠价",
  contactUs: "联系我们",
  limitQuantity: (quantity: number) => `限购${quantity}件`,
  queryFailed: "产品列表加载失败，请重试",
};
